export const APP_MODULE = 'app'

// Action && Mutation
export const RESET_STATE = 'resetState'
export const SET_IS_LOADING = 'setIsLoading'
export const SET_USER_AGENT = 'setUserAgent'

// Getter
export const FALLBACK_ROUTE = 'getFallbackRoute'
export const IS_LOADING = 'getIsLoading'
export const GET_USER_AGENT = 'getUserAgent'
export const TRANSLATE = 'translate'
export const DISABLED_SOCIAL = 'disabledSocial'
export const IS_PARTER = 'isPartner'
